import { Link } from "react-router-dom"
import './navbar.css'
  //will probably migrate the Links here to separate button components
function navbar() {
  return(
    <div style={{borderBottom:'2px solid black'}}>
      <ul className="navbarContainer">
        <div className="navbarButton">
          <Link to="/">

              <img src={'/assets/logo.png'} alt="Company logo"/>

          </Link>
        </div>

        <div className="navbarButton">
          <Link to="/Contact">Contact</Link>
        </div>

        <div className="navbarButton">
        <Link to="/About">About Us</Link>
        </div>

        <div className="navbarButton">
          <Link to="/Services">Services</Link>
        </div>
      </ul>
    </div>
  )
}

export default navbar